import { graphql, useStaticQuery } from 'gatsby';

type SiteWideModalQuery = {
  contentfulSiteMetadata: {
    siteWideModal: Queries.ModalFragmentFragment;
    includeModalPaths: string[];
  };
};

const useSiteWideModal = () => {
  const data = useStaticQuery<SiteWideModalQuery>(graphql`
    query SiteWideModal {
      contentfulSiteMetadata(slug: { eq: "site-metadata" }) {
        siteWideModal {
          ...ModalFragment
        }
        includeModalPaths
      }
    }
  `);

  const { siteWideModal, includeModalPaths } = data?.contentfulSiteMetadata ?? {
    siteWideModal: {},
    includeModalPaths: '',
  };

  return { siteWideModal, includeModalPaths };
};

export default useSiteWideModal;
